import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { OrderFinishPayload, OrderFinishResponseData } from "../types/order"

const postData = async (uuid: string | undefined, payload: OrderFinishPayload) => {
    const { data } = await api.post<OrderFinishResponseData>(
        `/orders/${uuid}/finish`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useOrderFinish = (uuid: string | undefined) => {
    return useMutation((payload: OrderFinishPayload) => {
        return postData(uuid, payload)
    })
}
